export enum TabOptions {
  RecentlyCreated = `Recently Created`,
  MostViewed = `Most Viewed`,
  Teams = `Teams`,
}

export interface SidebarEntity {
  isHidden: boolean;
  name: string;
  link: string;
  type: string;
}

export interface UserSidebarJsxProps {
  attrs?: {
    name: string;
    id: number;
    email: string;
    'project-id': number;
  };
  state: {
    mostViewed: SidebarEntity[];
    selectedTab: TabOptions;
    user: any; // TODO typing
  };
}
